// extracted by mini-css-extract-plugin
export default {"input":"input--hIC6x"};